export enum ContactUsActionTypes {
    CONTACT_LIST = '@@contactUs/CONTACT_LIST',
    CONTACT_LIST_SUCCESS = '@@contactUs/CONTACT_LIST_SUCCESS',
    CONTACT_LIST_ERROR = '@@contactUs/CONTACT_LIST_ERROR',

    CONTACT_ADD = '@@contactUs/CONTACT_ADD',
    CONTACT_ADD_SUCCESS = '@@contactUs/CONTACT_ADD_SUCCESS',
    CONTACT_ADD_ERROR = '@@contactUs/CONTACT_ADD_ERROR',

    CONTACT_DELETE = '@@contactUs/CONTACT_DELETE',
    CONTACT_DELETE_SUCCESS = '@@contactUs/CONTACT_DELETE_SUCCESS',
    CONTACT_DELETE_ERROR = '@@contactUs/CONTACT_DELETE_ERROR',

    CONTACT_UPDATE = '@@contactUs/CONTACT_UPDATE',
    CONTACT_UPDATE_SUCCESS = '@@contactUs/CONTACT_UPDATE_SUCCESS',
    CONTACT_UPDATE_ERROR = '@@contactUs/CONTACT_UPDATE_ERROR',

    CONTACT_UPDATE_SEQ = '@@contactUs/CONTACT_UPDATE_SEQ',
    CONTACT_UPDATE_SEQ_SUCCESS = '@@contactUs/CONTACT_UPDATE_SEQ_SUCCESS',
    CONTACT_UPDATE_SEQ_ERROR = '@@contactUs/CONTACT_UPDATE_SEQ_ERROR',
}
